(function () {
  if (window.BAReasonsTimeline) {
    window.BAReasonsTimeline.init(document);
    return;
  }

  var timelines = [];
  var listening = false;
  var ticking = false;
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function getCenterY(element) {
    var rect = element.getBoundingClientRect();
    return rect.top + window.pageYOffset + (rect.height / 2);
  }

  function updateTimeline(timeline) {
    var numbers = timeline.querySelectorAll('[data-reasons-number]');
    var items = timeline.querySelectorAll('[data-reasons-item]');

    if (!numbers.length || !items.length) {
      return;
    }

    if (prefersReducedMotion) {
      timeline.style.setProperty('--reasons-progress', '100%');
      items.forEach(function (item) {
        item.classList.add('is-active');
      });
      return;
    }

    var firstCenter = getCenterY(numbers[0]);
    var lastCenter = getCenterY(numbers[numbers.length - 1]);
    var marker = window.pageYOffset + (window.innerHeight * 0.58);
    var progress = firstCenter === lastCenter ? 1 : clamp((marker - firstCenter) / (lastCenter - firstCenter), 0, 1);

    timeline.style.setProperty('--reasons-progress', (progress * 100).toFixed(2) + '%');

    items.forEach(function (item) {
      var number = item.querySelector('[data-reasons-number]');

      if (number && marker >= getCenterY(number)) {
        item.classList.add('is-active');
      } else {
        item.classList.remove('is-active');
      }
    });
  }

  function updateAll() {
    ticking = false;
    timelines = timelines.filter(function (timeline) {
      return document.documentElement.contains(timeline);
    });
    timelines.forEach(updateTimeline);
  }

  function requestUpdate() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(updateAll);
    }
  }

  function bindListeners() {
    if (listening) {
      return;
    }

    listening = true;
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  function init(root) {
    var scope = root || document;
    var found = scope.querySelectorAll('[data-reasons-timeline]:not([data-reasons-bound])');

    found.forEach(function (timeline) {
      timeline.dataset.reasonsBound = 'true';
      timelines.push(timeline);
    });

    if (timelines.length) {
      bindListeners();
      requestUpdate();
    }
  }

  window.BAReasonsTimeline = {
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
